import { cycle } from 'utils/misc';

export const listPlaceholder = (list, count = 5) => {
  const classes = ['w-5/12', 'w-8/12', 'w-10/12'];

  for (let index = 0; index < count; index += 1) {
    const li = document.createElement('li');
    li.className = `animate-pulse h-5 rounded-full bg-grey ${cycle(classes)}`;
    list.appendChild(li);
  }
};

export const productPlaceholder = (classNames = '') => {
  const classes = ['w-3/4', 'w-3/5', 'w-4/6'];
  const item = document.createElement('div');
  item.classList = classNames;

  item.innerHTML = `
    <div class="animate-pulse bg-grey aspect-ratio aspect-ratio--4/5"></div>
    <div class="animate-pulse bg-grey mt-3 h-6 ${cycle(classes)}"></div>
    <div class="animate-pulse bg-grey mt-3 h-5 w-6/12"></div>
  `;

  return item;
};
